import { EMBEDDED_URL_PROPERTY_NAME, URL_PROPERTY_NAME } from '../utils/constants';
import ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';
import ExtractedUrl from 'owa-mail-store/lib/store/schema/ExtractedUrl';
import { mutatorAction } from 'satcheljs';
import getExtendedPropertyFromItem from '../utils/getExtendedPropertyFromItem';

export const updateExtractedUrlData = mutatorAction(
    'updateExtractedUrlData',
    (item: ClientItem) => {
        let extractedData: ExtractedUrl[] = [];
        [EMBEDDED_URL_PROPERTY_NAME, URL_PROPERTY_NAME].forEach(propertyName => {
            const extractedTeeUrlProperty = getExtendedPropertyFromItem(item, propertyName);
            if (extractedTeeUrlProperty) {
                const parsedProperty = JSON.parse(extractedTeeUrlProperty.Value);
                parsedProperty.forEach((entity: any) => {
                    extractedData.push({
                        EntityId: entity['@EntityId'],
                        TeePropertyReference: propertyName,
                        Url: entity['url'],
                    });
                });
            }
        });

        item.ExtractedUrlData = extractedData;
    }
);
